import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token: string | null | undefined): boolean {
  if (!token?.trim()) return true;

  try {
    const decoded = jwtDecode(token);

    if (!decoded || !decoded.exp) {
      return true;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp <= currentTime;
  } catch {
    return true;
  }
}
